import { required, Validator } from '@/entities/validation';
import { IssueRecordEditable } from '@/ui/pages/issue/issueTypes';

export const validate: Validator<IssueRecordEditable> = issue => [
  ...required(issue.title, 'title'),
];
